var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"placeholder":"请选择试题难度"},on:{"change":_vm.onChange},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}},[_c('el-option',{attrs:{"label":"全部","value":null}}),_vm._l((_vm.list),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }